// extracted by mini-css-extract-plugin
export default {"firstPart":"bonus-module__firstPart__aXT9j","secondPart":"bonus-module__secondPart__31rjt"};